import {UseQueryOptions} from 'react-query';
import {AxiosResponse} from 'axios';
import {useCustomMutate, useCustomPostQuery, useCustomQuery} from '../../../../../hooks/query';
import {KeyValueResponse} from '../../../../model';
import {
  GET_CANDIDATE_TYPES,
  GET_NATIONAL_EXAM_LEVELS,
  GET_RESULTS_APPEAL_DETAIL,
  POST_RAW_RESULTS_APPEAL_SEARCH,
  POST_RESULTS_APPEAL_EXPORT_EXCEL,
} from './keys';
import {
  getCandidateTypes,
  getNationalExamLevels,
  getResultsAppealDetails,
  postRawResultsAppealSearch,
  postResultsAppealExportExcel,
} from '../api-services/api';
import {ApiPathParam} from '../../../../../models/SearchParamSchema';
import {PaginatedData} from '../../../../../models/List';
import {ServiceError} from '../../../../../hooks/error';
import {
  AppealSummaryResponse,
  ResultsAppealSearchRequest,
  ResultsAppealSearchResponse,
} from '../../model';

export const useGetNationalExamLevel = () =>
    useCustomQuery<KeyValueResponse[]>(
        GET_NATIONAL_EXAM_LEVELS,
        () => getNationalExamLevels().then((res) => res.data),
        {
          staleTime: Infinity,
        }
    );

export const useGetCandidateTypes = () =>
    useCustomQuery<KeyValueResponse[]>(
        GET_CANDIDATE_TYPES,
        () => getCandidateTypes().then((res) => res.data),
        {
          staleTime: Infinity,
        }
    );

export const usePostRawResultsAppealSearch = (
    paging: ApiPathParam,
    payload: ResultsAppealSearchRequest,
    queryOptions: UseQueryOptions<AxiosResponse<PaginatedData<ResultsAppealSearchResponse>>,
        ServiceError,
        AxiosResponse<PaginatedData<ResultsAppealSearchResponse>>>
) =>
    useCustomPostQuery<AxiosResponse<PaginatedData<ResultsAppealSearchResponse>>,
        ResultsAppealSearchRequest>(
        [POST_RAW_RESULTS_APPEAL_SEARCH, paging, payload],
        (csrfToken, data) => postRawResultsAppealSearch(csrfToken, data, paging),
        queryOptions,
        payload,
        true,
        true
    );

export const usePostResultsAppealExportExcel = (
    onSuccess: (res: any) => void,
    onError: (res: any) => void
) =>
    useCustomMutate(POST_RESULTS_APPEAL_EXPORT_EXCEL, postResultsAppealExportExcel, {
      onSuccess,
      onError,
    });

export const useGetResultsAppealDetails = (uuid: string) =>
    useCustomQuery<AppealSummaryResponse>(
        [GET_RESULTS_APPEAL_DETAIL, uuid],
        () => getResultsAppealDetails(uuid).then((res) => res.data),
        {
          staleTime: Infinity,
        }
    );
